<template>
  <div class="fromBiao" id="formBtn">
    <el-form inline v-model="formInline" label-position="left" class="form">
      <el-form-item v-for="(item, index) in formData" :label="item.label + ':'" :key="index">
        <!--input框-->
        <el-input size="small" v-model="formInline[item.name]" :placeholder="item.label" v-if="item.type == 1">
        </el-input>
        <!--下拉-->
        <el-select size="small" filterable :clearable="item.isClear" v-model="formInline[item.name]"
          :placeholder="item.label" v-else-if="item.type == 2" v-loadMore="loadMore" popper-class="el-select-thick-scrollbar">
          <el-option v-for="(j, index2) in item.selects" :label="j.label" :value="j.value" :key="index2"></el-option>
        </el-select>
        <!--日期-->
        <el-date-picker size="small" v-model="formInline[item.name]" :type="item.dateType || 'date'"
          v-else-if="item.type == 3" :placeholder="item.label" value-format="yyyy-MM-dd">
        </el-date-picker>

        <el-date-picker size="small" v-model="formInline[item.name]" :type="item.dateType || 'date'"
          v-else-if="item.type == 7" :placeholder="item.label" value-format="yyyy-MM">
        </el-date-picker>

        <el-date-picker size="small" v-model="formInline[item.name]" :type="item.dateType || 'date'"
          v-else-if="item.type == 8" :placeholder="item.label" value-format="yyyy">
        </el-date-picker>

        <el-date-picker size="small" style="width: 250px;"  v-model="formInline[item.name]" v-else-if="item.type == 4"
          :clearable="item.isClear" :type="item.dateType || 'daterange'" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" value-format="yyyy-MM-dd">
        </el-date-picker>

        <!-- 级联选项 -->
        <el-cascader size="small" v-model="formInline[item.name]" :options="item.selects" v-else-if="item.type == 5"
          :props="{ checkStrictly: true }" clearable></el-cascader>

        <!-- 自定义数字范围 -->
        <input-range v-model="formInline[item.name]" :value="formInline[item.name]" v-else-if="item.type == 6"
          :precision="item.precision"></input-range>
      </el-form-item>

      <span class="itemBtn">
        <el-button type="warning" size="mini" @click="onSubmit">查询</el-button>
        <el-button plain size="mini" @click="reset">重置</el-button>
      </span>
    </el-form>
  </div>
</template>

<script>
  import {
    mapActions,
    mapGetters
  } from 'vuex';
  import inputRange from '@/components/inputRange/inputRange.vue';
  export default {
    directives: {
      loadMore: {
        bind(el, binding) {
          // 获取element，定义scroll
          let select_dom = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
          select_dom.addEventListener('scroll', function() {
            let height = this.scrollHeight - this.scrollTop <= this.clientHeight;
            if (height) {
              binding.value()
            }
          })
        }
      }
    },
    props: ["formData", "dontReset"],
    data() {
      return {
        formInline: {},
        unitData: null
      }
    },
    components: {
      "input-range": inputRange
    },
    computed: {
      ...mapGetters([
        // 'emptyFrom',
      ])
    },
    mounted() {
      this.formInline = {};
      this.formData.forEach((item, index) => {
        if (item.value !== '' && item.value !== undefined) {
          this.$set(this.formInline, item.name, item.value)
        }
      });
    },

    methods: {
      ...mapActions([
        'getEmptyFromData'
      ]),
      loadMore() {
        this.$emit("loadMore", {});
      },
      updataText(data, isSearch) {
        if (data.value !== '' && data.value !== undefined) {
          this.$set(this.formInline, data.name, data.value)
          this.unitData = data
        } else if (data.name !== '' && data.name !== undefined) {
          this.$set(this.formInline, data.name, null)
          this.unitData = null
        }

        if (isSearch) {
          this.onSubmit()
        }
      },
      test(){
        console.log("2233");
      },
      updataData(key, obj) {
        this.$set(this.formInline, key, obj)
      },
      onSubmit() {
        this.$emit("queryData", this.formInline, false);
      },
      reset() {
        let that = this;
        this.formInline = {};

        if (this.dontReset) {
          this.dontReset.forEach(e => {
            if (e.value !== '' && e.value !== undefined) {
              that.$set(this.formInline, e.name, e.value)
            }
          })
        }
        if (this.unitData) {
          that.$set(this.formInline, this.unitData.name, this.unitData.value)
        }
        this.$emit("queryData", this.formInline, true);
      },
      updateData(isQuery) {

        this.formData.forEach((item, index) => {
          if (item.value !== '' && item.value !== undefined) {
            this.$set(this.formInline, item.name, item.value, )
          }
        });
        if (isQuery) {
          this.$emit("queryData", this.formInline);
        }


      },
      getSearchData() {
        return this.formInline
      }

    },
    watch: {
      emptyFrom() {
        // this.formInline = this.emptyFrom;
      }
    }
  }
</script>

<style lang="scss">
  .fromBiao {
    flex-shrink: 0;
    margin-top: 20px;
    position: relative;

    &.mt0 {
      margin-top: 0;
    }

    .form {
        text-align: left;
        padding: 23px 20px 23px 0px;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end !important;

        .el-form-item {
          width: calc((100% - 120px) / 6);
          margin-right: 20px;
          margin-bottom: 20px !important;
          line-height: 32px;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          .el-form-item__label {
            float: none;
            display: block;
            width: auto;
            padding: 0 0 4px;
            line-height: 20px;
            white-space: nowrap;
          }

          .el-form-item__content {
            margin-left: 0 !important;
            line-height: 32px;
            width: 100%;

            .el-select,
            .el-input,
            .el-date-editor,
            .el-cascader {
              width: 100%;
            }
          }
        }

        .el-form-item:last-child {
          margin-right: 0;
        }

        .el-date-editor {
          .el-range-input {
            width: 40%;
          }
          .el-range-separator{
            line-height: 26px;
            width: 10%;
          }
          .el-range__close-icon {
            margin-right: -7px;
          }
        }

        .itemBtn {
          display: flex;
          margin-left: auto;
          align-self: flex-start !important;
          margin-top: 24px;
          margin-bottom: 20px;
        }

        .el-form-item__label {
          font-size: 14px;
        }

        .el-input__inner {
          height: 36px;
          line-height: 36px;
          font-size: 14px;
        }

        .el-button {
          width: 73.90px;
          height: 36px;
          font-size: 14px;
          border-radius: 5px;
        }

        .el-button--warning {
          background-color: #386BFF;
          border-color: #386BFF;
        }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/search/mySearch.vue